import axios from 'axios';

//staging
//const API_BASE_URL = 'https://wzdjrcmixbgulouqykxt.supabase.co/functions/v1';
//production
const API_BASE_URL = 'https://vhpukeeurjiylhjrwosv.supabase.co/functions/v1';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('accessToken');
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

// --- Subscription APIs ---
export const getSubscriptionPlans = () => apiClient.get('/ecpay/subscription-plans', { headers: { 'X-Viewer-Country': 'TW' } });
export const createSubscription = (subscriptionPlanId) => apiClient.post('/ecpay/subscriptions', { subscriptionPlanId });
export const getUserSubscription = () => apiClient.get('/ecpay/subscriptions');
export const updateSubscription = (subscriptionPlanId) => apiClient.patch('/ecpay/subscriptions', { subscriptionPlanId });
export const cancelSubscription = () => apiClient.delete('/ecpay/subscriptions');
export const resumeSubscription = () => apiClient.post('/ecpay/subscriptions/resume');

// --- Credit Card APIs ---
export const getBoundCreditCards = () => apiClient.get('/ecpay/credit-cards');
export const initiateCardBinding = () => apiClient.post('/ecpay/credit-cards');
export const createBindCardTransaction = (payload) => apiClient.post('/ecpay/credit-cards/transaction', payload);
export const deleteCreditCard = (cardId) => apiClient.delete(`/ecpay/credit-cards/${cardId}`);
export const setDefaultCreditCard = (cardId) => apiClient.post('/ecpay/credit-cards/default', { cardId });

// --- MKPU APIs ---
export const getMkpuPricing = () => apiClient.get('/ecpay/mkpu/pricing');
export const getMkpuBalance = () => apiClient.get('/ecpay/mkpu/balance');
export const purchaseMkpu = (purchaseData) => apiClient.post('/ecpay/mkpu/purchase', purchaseData);
export const setMkpuThreshold = (threshold) => apiClient.patch('/ecpay/mkpu/threshold', { threshold });

// --- Payment History API ---
export const getPaymentHistories = () => apiClient.get('/ecpay/payment-histories');


// --- Developer Tools APIs ---
export const devClearSubscriptions = () => apiClient.delete('/ecpay/temp/subscriptions');
export const devClearTrialHistory = () => apiClient.delete('/ecpay/temp/trial-subscriptions');
export const devClearPaymentHistories = () => apiClient.delete('/ecpay/temp/payment-histories');

// --- Redeem Subscription APIs ---
export const getRedeemSubscriptions = () => apiClient.get('/ecpay/subscriptions/redeem');
export const getSubscriptionTiers = () => apiClient.get('/ecpay/subscriptions/tiers');
export const createRedeemSubscription = (payload) => apiClient.post('/ecpay/subscriptions/redeem', payload);
export const deleteRedeemSubscription = (redeemSubscriptionId) => apiClient.delete(`/ecpay/subscriptions/redeem/${redeemSubscriptionId}`);

// --- User Redemption APIs ---
export const checkRedeemCode = (redeemCode) => apiClient.post('/ecpay/subscriptions/redeem-plans', { redeemCode });
export const activateRedeemedSubscription = (payload) => apiClient.patch('/ecpay/subscriptions', payload);

// --- Discount Code APIs ---
export const adminCreateDiscountCode = (payload) => apiClient.post('/ecpay/discounts', payload);
export const adminListDiscountCodes = () => apiClient.get('/ecpay/discounts');
export const adminDeleteDiscountCode = (codeId) => apiClient.delete(`/ecpay/discounts/${codeId}`);
export const activateDiscountCode = (redeemCode) => apiClient.post('/ecpay/discounts/activate', { redeemCode });
export const getDiscountStatus = () => apiClient.get('/ecpay/discounts/status');

// --- Access Pass APIs ---
export const checkAccessPass = (redeemCode) => apiClient.post('/ecpay/subscriptions/access-pass/check', { redeemCode });
export const activateAccessPass = (redeemCode) => apiClient.post('/ecpay/subscriptions/access-pass/activate', { redeemCode });
export const getAccessPassStatus = () => apiClient.get('/ecpay/subscriptions/access-pass');
export const adminCreateAccessPass = (payload) => apiClient.post('/ecpay/access-pass', payload);
export const adminListAccessPass = () => apiClient.get('/ecpay/access-pass');
export const adminDeleteAccessPass = (codeId) => apiClient.delete(`/ecpay/access-pass/${codeId}`);